var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-5 pr-5 pt-4 pb-1"},[_c('div',{staticClass:"is-size-5 has-text-weight-semibold"},[_vm._v("Speed distribution")]),_c('hr',{staticClass:"solid-thin mt-2 mb-1"}),_c('div',{attrs:{"id":"chart"}},[_c('apex-chart',{attrs:{"type":"bar","height":"300","options":_vm.chartOptions,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }